import PropTypes from 'prop-types';
import CmsSportCouponViewImpl from './cms-sport-coupon-view.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
const UIView = MojitoCore.Presentation.UIView;

/**
 * A view rsponsible for displaying a sport-specific coupon.
 *
 * @class CmsSportCouponView
 * @private
 * @memberof Mojito.Modules.CmsSportCoupon
 */

/**
 * `CmsSportCouponView` prop types.
 *
 * @property {string} sportId - The sport id.
 * @property {string} couponId - The coupon id.
 * @property {string} couponName - The name of the coupon.
 * @property {Function} [onDataLoad = () => {}] - A callback function triggered when all child elements have finished loading.
 *
 * @memberof Mojito.Modules.CmsSportCoupon.CmsSportCouponView
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    couponId: PropTypes.string.isRequired,
    couponName: PropTypes.string.isRequired,
    onDataLoad: PropTypes.func,
};

const defaultProps = {
    onDataLoad: noop,
};

export default UIView('CmsSportCouponView', CmsSportCouponViewImpl, propTypes, defaultProps);
